import React from 'react';
import { figures, mentorFigures } from './rpgCast';

export const RPGFigure = ({ id, className = '', testId, alt }) => {
  const figure = figures.find((item) => item.id === id) || figures[0];
  return <img data-testid={testId} src={figure.src} alt={alt || figure.label} width="256" height="320" draggable="false" className={`mc-rpg-figure ${className}`} />;
};

export const MasterclassMentor = ({ specialty, figureId, small = false, testId = 'masterclass-mentor' }) => (
  <RPGFigure id={figureId || mentorFigures[specialty] || 'general'} testId={testId} className={small ? 'mc-mentor-small' : 'mc-mentor'} />
);